import { render, staticRenderFns } from "./vListRecipeCost.vue?vue&type=template&id=5c8e632e&scoped=true"
import script from "./vListRecipeCost.vue?vue&type=script&setup=true&lang=ts"
export * from "./vListRecipeCost.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./vListRecipeCost.vue?vue&type=style&index=0&id=5c8e632e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c8e632e",
  null
  
)

export default component.exports